import React from "react";
import "./HorizontalScrollbar.css";

function HorizontalScrollbar2() {
  return (
    <>
      <div class="test">
        <div>
          <span id="first" class="border-change circle"></span>
        </div>
        <div>
          <span id="second" class="circle"></span>
        </div>
      </div>
    </>
  );
}

export default HorizontalScrollbar2;
